const SETTING_BASE_URL = '/api/v1/setting';

const SETTING_ENDPOINTS = {
  GET_CATEGORIES: SETTING_BASE_URL + '/getCategories', // gives back the settings
};

export default SETTING_ENDPOINTS;